import PropTypes from"prop-types";export var componentType=PropTypes.oneOfType([PropTypes.string,PropTypes.func,PropTypes.node,PropTypes.object]);